import { entities } from "sbtech-sports-data-api-client";
import { MarketFilter } from "../Interfaces";

enum FTMarketTypeId
{
    ML = "1_0",
    HC = "2_0",
    OU = "3_0"
}

export class MoneyLineAllMarketFilter implements MarketFilter {
    isMatch(market: entities.Market): boolean {
        return true;
    }
    isValid(market: entities.Market): boolean {
        return market.marketType.id === FTMarketTypeId.ML;
    }
}